import { graphql, NetworkStatus, useQuery, } from '@biscuits/graphql';
import { useEffect } from 'react';
import { useMaybeAppId } from '../common/Context.js';
// some minimal queries for common use
const meQuery = graphql(`
	query CommonMe($appId: String!) {
		me {
			id
			name
			imageUrl
			plan {
				id
				hasAppAccess(appId: $appId)
				subscriptionStatus
				featureFlags
			}
			acceptedTermsOfServiceAt
		}
	}
`);
export function useMe() {
    const appId = useMaybeAppId();
    const res = useQuery(meQuery, {
        fetchPolicy: 'cache-first',
        variables: { appId: appId || '' },
        context: { hideErrors: true },
    });
    // setup to refetch on window visible if the query
    // was unsuccessful
    const { refetch, error } = res;
    useEffect(() => {
        if (error) {
            const handler = () => {
                refetch();
            };
            window.addEventListener('visibilitychange', handler);
            return () => {
                window.removeEventListener('visibilitychange', handler);
            };
        }
    }, [refetch, error]);
    return res;
}
export function useIsLoggedIn() {
    var _a, _b;
    const result = useMe();
    return [
        !!((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.me) === null || _b === void 0 ? void 0 : _b.id),
        result.networkStatus === NetworkStatus.loading ||
            result.networkStatus === NetworkStatus.refetch ||
            isOfflineError(result.error),
    ];
}
export function useHasServerAccess() {
    var _a, _b, _c;
    const result = useMe();
    return (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.me) === null || _b === void 0 ? void 0 : _b.plan) === null || _c === void 0 ? void 0 : _c.hasAppAccess;
}
export function useIsOffline() {
    const { error } = useMe();
    return isOfflineError(error);
}
function isOfflineError(error) {
    var _a;
    if (!error)
        return false;
    if (!error.networkError)
        return false;
    if (
    // Chrome
    error.networkError.message === 'Failed to fetch' ||
        (
        // FF
        (_a = error.networkError.message) === null || _a === void 0 ? void 0 : _a.includes('NetworkError when attempting')))
        return true;
    if ('statusCode' in error.networkError) {
        return (error.networkError.statusCode === 0 ||
            error.networkError.statusCode >= 500);
    }
    return false;
}
//# sourceMappingURL=graphql.js.map